import { CookieConsentBanner } from "@web/components/cookie-consent-banner";
import { FloatWhatsAppButton } from "@web/components/float-whatsapp-button";
import { FooterSection } from "@web/components/sections/footer";
import { Nav } from "@web/components/sections/nav";
import { api } from "@web/lib/axios";
import { useLanguage } from "@web/lib/contexts/language-context";
import { isAxiosError } from "axios";
import { useLayoutEffect } from "react";
import { Outlet, useLocation, useNavigate } from "react-router";

export const AppLayout = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  useLayoutEffect(() => {
    const interceptorId = api.interceptors.response.use(
      (response) => response,
      (error) => {
        if (isAxiosError(error)) {
          const status = error.response?.status;
          const statusText = error.response?.statusText.toUpperCase();

          if (status === 401 && statusText === "UNAUTHORIZED") {
            navigate("/entrar", {
              replace: true,
            });
          }
        }

        return Promise.reject(error);
      },
    );

    return () => {
      api.interceptors.response.eject(interceptorId);
    };
  }, [navigate]);

  return (
    <div
      className="flex min-h-screen flex-col bg-gray-50"
      dir={language === "ar" ? "rtl" : "ltr"}
    >
      {location.pathname !== "/camera" && <Nav />}
      <Outlet />
      {location.pathname !== "/camera" && <FooterSection />}

      {location.pathname !== "/camera" && <FloatWhatsAppButton />}
      {location.pathname !== "/camera" && <CookieConsentBanner />}
    </div>
  );
};
